// When a post was uploaded, as the short relative time people know from
// Instagram and co. ("just now", "5m ago", "2h ago", "3d ago"), switching to
// a plain date after a week. The exact date and time is in the tooltip.
function formatPostTime(dateString) {
  const then = new Date(dateString);
  const ms = then.getTime();
  if (Number.isNaN(ms)) return "";

  const seconds = Math.max(0, Math.floor((Date.now() - ms) / 1000));
  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;

  const sameYear = then.getFullYear() === new Date().getFullYear();
  return then.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    ...(sameYear ? {} : { year: "numeric" })
  });
}

export default function PostTime({ date }) {
  if (!date) return null;
  const text = formatPostTime(date);
  if (!text) return null;

  return (
    <time dateTime={new Date(date).toISOString()} title={new Date(date).toLocaleString()} style={timeText}>
      {text}
    </time>
  );
}

// Stacks the @username with the time under it inside a post's header, without
// making the header any taller than the avatar next to it.
export const postNameColumn = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  lineHeight: 1.2,
  minWidth: 0
};

const timeText = {
  fontSize: 12,
  fontWeight: 400,
  color: "var(--text-muted)"
};
